import Vue from 'vue';
import SkyScheme from './sky-scheme';

Vue.component('sky-scheme', SkyScheme);

export default SkyScheme;



// WEBPACK FOOTER //
// ./scripts/sky-scheme/index.js